import React, { Component } from "react";
import _ from "lodash";
import Button from "../base-components/button"
import { sendAPIRequest } from "shared/utils/requests";

class Training extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };

  }

  static getDerivedStateFromProps(props, state) {

    return null;
  }

  componentDidMount = () => {
  }

  componentDidUpdate(_, prevState) {
    
  }

  componentWillUnmount() {
  }

  async submitTraining() {
    const {
      updateOnboardingStep,
    } = this.props;

    const response = await sendAPIRequest(`/onboarding/submit_training`, "POST", { });
    if (response.data.status == 'success') {
      updateOnboardingStep(response.data.onboardingStep);
    } else {
      throw new Error("invalid status for training submission: " + response.data.status)
    }
  }

  render() {
    const {
      currentContractor,
    } = this.props;

    return (
      <div className="onboarding-training-container">
        <div className="onboarding-title">
          Review Training Videos, Guidelines, and Sample Transcripts
        </div>
        <div className="onboarding-biglabel onboarding-training-body">
          We strongly recommend you watch training videos and review sample transcripts before you begin transcribing. Transcribing can be tricky and even the best transcribers like to practice! These resources are available on our site but we suggest you take the time to review them now:
        </div>
        <div className="onboarding-biglabel onboarding-training-links">
          <a href="https://youtu.be/ACdkOAuL9Rc" target="_blank" rel="noopener noreferrer">Training Video Part 1</a>
          <br /> <br />
          <a href="https://youtu.be/k7nPvciQdy0" target="_blank"  rel="noopener noreferrer">Training Video Part 2</a>
          <br /> <br />
          <a href="https://docs.google.com/document/d/1sMPnNNwyuMq1IsDU-12cT-74JUAx3J9A3lg5sFZfHOA/edit?usp=sharing" target="_blank"  rel="noopener noreferrer">Quality Rating Guidelines</a>
          <br /> <br />
          <a href="https://docs.google.com/document/d/15WuPcQ3uHvCYgGdgw6HP8NNInnldClYV8VBRmLJuY8I/edit?usp=sharing" target="_blank"  rel="noopener noreferrer">Sample Transcripts</a>
        </div>
        <div className="onboarding-divider"/>
        <div className="onboarding-submission">
          <Button className="onboarding-submission-button" onClick={() => this.submitTraining()} text="Continue" />
        </div>
      </div>
    );  }

}

export default Training;
